import { useMemo } from "react";

import type { WorkspaceNode } from "../../../types/workspace";
import { normalizeReportTypeKey } from "../../../utils/reportTypeRules";
import {
  EMPTY_WORKSPACE_FOCUS_ENRICHMENT,
  type WorkspaceFocusEnrichment,
} from "./workspaceFocusFilter";

/**
 * Report-type focus chips from workspace `node.meta.reportType` — no GET /reports fan-out.
 */
export function useWorkspaceFocusEnrichment(
  nodes: WorkspaceNode[] | undefined
): WorkspaceFocusEnrichment {
  return useMemo(() => {
    const reportTypeByEntityId: Record<string, string> = {};
    for (const node of nodes ?? []) {
      if (node.type !== "report") continue;
      const raw = node.meta?.reportType?.trim();
      if (!raw) continue;
      const reportType = normalizeReportTypeKey(raw) || raw;
      if (reportType) reportTypeByEntityId[node.entityId] = reportType;
    }
    if (Object.keys(reportTypeByEntityId).length === 0) {
      return EMPTY_WORKSPACE_FOCUS_ENRICHMENT;
    }
    return { reportTypeByEntityId };
  }, [nodes]);
}
